<template>
  <details class="simple" open>
    <summary>Gráfica de productividad</summary>
    <GChart type="BubbleChart" :data="chartData" :options="chartOptions" v-if="items.length" />
    <b-alert v-else variant="info" show> No hay datos suficientes para mostrar la gráfica. </b-alert>
  </details>
</template>
<script>
import { GChart } from "vue-google-charts/legacy";
import { makeBubbleOptions } from "./bubbleChartOptions.js";

function colorPorProductividad(productividad) {
  if (productividad > 10) {
    return "> 10%";
  } else if (productividad > 5) {
    return "> 5%";
  } else {
    return "<= 5%";
  }
}

export default {
  components: {
    GChart,
  },
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    chartData() {
      const table = [["Comercial", "Promedio Días Cierre", "Productividad", "Nivel productividad", "Ganadas"]];
      this.items.forEach((item) => {
        const color = colorPorProductividad(item.productividad);
        table.push([item.comercial, item.promedioGanadas, item.productividad, color, item.ganadas]);
      });
      table.sort((a, b) => b[2] - a[2]);
      return table;
    },
  },
  data() {
    return {
      chartOptions: makeBubbleOptions({
        hAxis: { title: "Promedio Días Cierre (solo ganadas)", minValue: 0 },
        vAxis: { title: "Productividad", minValue: 0 },
        series: {
          "> 10%": { color: "#2ecc71" },
          "> 5%": { color: "#f1c40f" },
          "<= 5%": { color: "#e74c3c" },
        },
      }),
    };
  },
};
</script>
